module.exports = __webpack_public_path__ + "img/cms_asset_create.4ce2096b.jpg";